import { h } from 'preact';
import { CHIP_VARIANTS } from './Chip.constants';
import { ChipContainer } from './Chip.styles';

type VariantsKeys = keyof typeof CHIP_VARIANTS;
type VariantsValues = typeof CHIP_VARIANTS[VariantsKeys];

export interface ChipProps extends React.ButtonHTMLAttributes<HTMLDivElement> {
  className?: string;
  variant?: VariantsValues;
  onClick?: () => void;
}

const Chip: React.FC<ChipProps> = (props) => {
  const {
    className = '',
    children,
    variant = CHIP_VARIANTS.outlined,
    onClick,
    'aria-checked': ariaChecked,
    role,
  } = props;

  return (
    <ChipContainer
      className={className}
      data-testid="tracking-details-chip"
      variant={variant}
      onClick={onClick}
      aria-checked={ariaChecked}
      role={role}
    >
      {children}
    </ChipContainer>
  );
};

export default Chip;
